$(document).on('click', '.js-employeeAccordToggle', function() {
  const $header = $(this);

  $header.parent().toggleClass('is_active');
  $header.next().slideToggle(200);
});

$(document).on('click', '.js-employeeProjectToggle', function() {
  const $project = $(this).closest('.employee-project');
  const $details = $project.find('.employee-project__details');

  if ($project.hasClass('is_active')) {
    $details.stop(true, true).slideUp(200, () => {
      $project.removeClass('is_active');
    });
  } else {
    $project.addClass('is_active');
    $details.stop(true, true).slideDown(200);
  }
});

$('.employee-project.is_active .employee-project__details').show();
